"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectRecurringAppointmentScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _components = require("../../../components");
var _ = require("../..");
var _CubbyFooter = _interopRequireDefault(require("../CubbyFooter"));
var _SelectedSlotMessage = require("./SelectedSlotMessage");
var _utils2 = require("../utils");
var _useManagerAppointmentCubby = require("../useManagerAppointmentCubby");
var _ScreenTitle = require("./ScreenTitle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FrequencyOption = /*#__PURE__*/function (FrequencyOption) {
  FrequencyOption[FrequencyOption["Weekly"] = 1] = "Weekly";
  FrequencyOption[FrequencyOption["Biweekly"] = 2] = "Biweekly";
  return FrequencyOption;
}(FrequencyOption || {});
var FrequencyOptionProps = [{
  value: FrequencyOption.Weekly,
  label: 'Weekly'
}, {
  value: FrequencyOption.Biweekly,
  label: 'Every other week'
}];
var SelectRecurringAppointmentScreen = function SelectRecurringAppointmentScreen() {
  var _useManagerAppointmen = (0, _useManagerAppointmentCubby.useManagerAppointmentCubby)(),
    patient = _useManagerAppointmen.patient,
    clinician = _useManagerAppointmen.clinician,
    appointmentScheduled = _useManagerAppointmen.appointmentScheduled,
    previousStage = _useManagerAppointmen.previousStage,
    transition = _useManagerAppointmen.transition;
  var _useState = (0, _react.useState)(FrequencyOptionProps[0].value),
    _useState2 = _slicedToArray(_useState, 2),
    intervalFrequency = _useState2[0],
    setIntervalFrequency = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSlot = _useState4[0],
    setSelectedSlot = _useState4[1];
  var _useCacheKey = (0, _utils.useCacheKey)('recurring-availability'),
    _useCacheKey2 = _slicedToArray(_useCacheKey, 2),
    recurringAvailabilityKey = _useCacheKey2[0],
    onInvalidateAvailability = _useCacheKey2[1];
  var _useRequest = (0, _utils.useRequest)(function () {
      var eventType = (0, _utils.getEventTypeForClinician)(clinician);
      var duration = _utils.BookingEventTypeDuration[eventType];

      // Recurring rules are always created with the clinician's timezone
      // to keep the appointment times consistent for the clinician across DST.
      var slotInRuleTZ = (0, _momentTimezone.default)(selectedSlot.start).tz(clinician.timeZone);
      return {
        method: 'post',
        url: (0, _utils.getCreateRecurringAppointmentUrl)(patient.id),
        data: {
          clinicianId: clinician.id,
          timeZone: clinician.timeZone,
          interval: 'week',
          intervalFrequency: intervalFrequency,
          day: (0, _utils.toDayOfWeek)(slotInRuleTZ),
          start: slotInRuleTZ.format(_utils.RECURRING_TIME_START_FORMAT),
          anchorDate: slotInRuleTZ.toDate(),
          duration: duration,
          eventType: eventType
        },
        withErrorsHandler: false
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        return transition('newSuccess');
      },
      onError: function onError(error) {
        setSelectedSlot(undefined);
        onInvalidateAvailability();
        (0, _utils2.handleAppointmentError)(error);
      }
    }),
    createAppointmentLoading = _useRequest.loading,
    createAppointment = _useRequest.runAsync;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h-full flex flex-col relative"
  }, /*#__PURE__*/_react.default.createElement(_ScreenTitle.ScreenTitle, {
    className: "px-[24px]"
  }, "Select a recurring appointment slot"), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "mt-[24px] border-grey-25"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-grow h-0 overflow-y-auto"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full flex px-[24px] pt-[24px] pb-[12px] gap-x-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_components.Radio.Group, {
    name: "intervalFrequency",
    value: intervalFrequency,
    onChange: function onChange(e) {
      return setIntervalFrequency((0, _lodash.toNumber)(e.target.value));
    }
  }, FrequencyOptionProps.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_components.Radio, {
      key: option.value,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/_react.default.createElement(_.RecurringAppointmentSelector, {
    value: selectedSlot,
    onSelect: setSelectedSlot,
    clinician: clinician,
    intervalFrequency: intervalFrequency,
    cacheKey: recurringAvailabilityKey
  })), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "mb-[24px] border-grey-25"
  }), /*#__PURE__*/_react.default.createElement(_CubbyFooter.default, {
    message: /*#__PURE__*/_react.default.createElement(_SelectedSlotMessage.RecurringSelectedSlotMessage, {
      intervalFrequency: intervalFrequency,
      selectedSlot: selectedSlot,
      patientTimeZone: patient.timeZone,
      clinicianTimeZone: clinician.timeZone
    }),
    loading: createAppointmentLoading,
    actionText: "Schedule",
    actionDisabled: appointmentScheduled || !(selectedSlot && patient) || createAppointmentLoading,
    onAction: createAppointment,
    cancelText: previousStage ? 'Back' : 'Cancel',
    onCancel: function onCancel() {
      return transition('back');
    }
  }));
};
exports.SelectRecurringAppointmentScreen = SelectRecurringAppointmentScreen;